import React, { useEffect, useState } from "react";
import { Button, Input, Pagination, Table, Tooltip, Whisper } from "rsuite";
import { handleDownloadAsExcel } from "../../../Helpers/Utils";
import { SubStateVM } from "../../../Models/ViewModels";
import { GetSubStateDetails } from "../../../Services/SubStateDB";
import { BootstrapIcon } from "../../../SharedComponents/BootstrapIcon";
import { CustomTableCell } from "../../../SharedComponents/CustomTableCell";
import { CustomTableHeaderCell } from "../../../SharedComponents/CustomTableHeaderCell";
import { PageHeader } from "../../../SharedComponents/PageHeader";
import { SubStateModal } from "./SubStateModalDisp";

const { Column, HeaderCell, Cell } = Table;
export const SubStateList = () => {
  const [cachedSubstateList, setCachedSubStateList] = useState(
    new Array<SubStateVM>()
  );
  const [sortColumn, setSortColumn] = useState();
  const [isLoading, setLoading] = useState(true);
  const [sortType, setSortType] = useState();
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(15);
  const [filteredSubstateList, setFilteredSubstateList] = useState(
    new Array<SubStateVM>()
  );

  const [searching, setSearching] = useState(false);

  useEffect(() => {
    GetSubstateList();
  }, []);

  const GetSubstateList = () => {
    GetSubStateDetails().then((res: any) => {
      setCachedSubStateList(res.data);
      setFilteredSubstateList(res.data);
      setLoading(false);
    });
  };

  const handleFilterData = (val: string, e: any) => {
    let searchText = val;
    setPage(1);
    if (searchText) {
      setFilteredSubstateList(
        cachedSubstateList.filter((e) =>
          JSON.stringify(e).toLowerCase().includes(searchText.toLowerCase())
        )
      );
      setSearching(true);
    } else {
      setFilteredSubstateList([...cachedSubstateList]);
      setSearching(false);
    }
  };

  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  const tableDataFeed = filteredSubstateList.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const handleSortColumn = (sortColumn: any, sortType: any) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
    if (sortColumn && sortType) {
      return filteredSubstateList.sort((a: any, b: any) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string" || "") {
          x = x.charCodeAt();
        }
        if (typeof y === "string" || "") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
  };

  const ProcessInfo: SubStateVM = new SubStateVM();

  const addSubstate = (prrDetail: SubStateVM) => {
    GetSubstateList();
  };
  const editSubstate = (prrDetail: SubStateVM) => {
    GetSubstateList();
  };
  const deleteSubstate = (prrDetail: SubStateVM) => {
    GetSubstateList();
  };
  return (
    <>
      <div className="row">
        <div className="col-md-7">
          <PageHeader title="SubState Master" backPage="">
            <></>
          </PageHeader>
        </div>
        <div className="col-md-3">
          <Input
            className="form-control border border-dark"
            placeholder="Search..."
            type={"search"}
            id="search"
            onChange={handleFilterData}
          />
        </div>
        <div className="col-md-1">
          {searching == true ? (
            <button
              id="color"
              onClick={() => handleDownloadAsExcel(tableDataFeed)}
            >
              <BootstrapIcon
                bootStrapIconName={"file-earmark-arrow-down-fill"}
                size={30}
                cssClasses={"pe-2"}
              />{" "}
            </button>
          ) : (
            <button
              id="color"
              onClick={() => handleDownloadAsExcel(cachedSubstateList)}
            >
              <BootstrapIcon
                bootStrapIconName={"file-earmark-arrow-down-fill"}
                size={35}
                cssClasses={"pe-2"}
              />{" "}
            </button>
          )}
        </div>
        <div className="col">
          <SubStateModal
            action="add"
            data={ProcessInfo}
            cachedData={cachedSubstateList}
            onAction={addSubstate}
          />
          <br />
        </div>
        <hr />
      </div>

      <div className="show-container " bg-color="pink">
        <Table
          id="table"
          data={tableDataFeed}
          height={450}
          loading={isLoading}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={handleSortColumn}
          bordered={true}
          cellBordered={true}
          className="border border-dark mt-2"
          autoHeight={true}
          rowHeight={30}
          headerHeight={30}
        >
          <Column flexGrow={50} align="center" fixed sortable>
            <CustomTableHeaderCell placement={"ID"}>ID</CustomTableHeaderCell>
            <CustomTableCell dataKey="SubStateId" />
          </Column>

          <Column flexGrow={300} align="center" fixed sortable>
            <CustomTableHeaderCell placement={"SubState Name"}>
              SubState Name
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="SubStateName" />
          </Column>

          <Column flexGrow={160} align="center" fixed>
            <CustomTableHeaderCell placement={"Process Name"}>
              Process Name
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="ProcessName" />
          </Column>

          <Column flexGrow={170} align="center" fixed>
            <CustomTableHeaderCell placement={"CaseType"}>
              CaseType
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="CaseType" />
          </Column>
          <Column flexGrow={130} align="center" sortable>
            <CustomTableHeaderCell placement={">VC From State"}>
              VC From State
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="VCFromState" />
          </Column>
          <Column flexGrow={100} align="center" sortable>
            <CustomTableHeaderCell placement={"VC To State"}>
              VC To State
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="VCToState" />
          </Column>
          <Column flexGrow={80} align="center" sortable>
            <CustomTableHeaderCell placement={"Payer"}>
              Payer
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="Payer" />
          </Column>
          <Column flexGrow={80} align="center" sortable>
            <CustomTableHeaderCell placement={"Action"}>
              Action
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="Action" />
          </Column>
          <Column flexGrow={130} align="center" sortable>
            <CustomTableHeaderCell placement={"Status"}>
              Status
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="Status" />
          </Column>

          <Column flexGrow={100} align="center">
            <CustomTableHeaderCell placement={"Action"}>
              Action
            </CustomTableHeaderCell>
            <CustomTableCell>
              {(rowData: SubStateVM) => {
                if (rowData.Status === "Active") {
                  return (
                    <div className="d-flex justify-content-center align-items-center flex-row gap-2">
                      <SubStateModal
                        action="delete"
                        data={rowData}
                        cachedData={cachedSubstateList}
                        onAction={deleteSubstate}
                      />
                      <SubStateModal
                        action="edit"
                        data={rowData}
                        cachedData={cachedSubstateList}
                        onAction={editSubstate}
                      />
                    </div>
                  );
                } else {
                  return (
                    <BootstrapIcon
                      bootStrapIconName="x-circle-fill text-danger"
                      size={15}
                      cssClasses="me-1"
                    ></BootstrapIcon>
                  );
                }
              }}
            </CustomTableCell>
          </Column>
        </Table>

        {filteredSubstateList && (
          <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="md"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              total={filteredSubstateList.length}
              limitOptions={[10, 15, 20, 25, 30]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        )}
      </div>
    </>
  );
};
